import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/styles/jquery.fullpage.min.css'
import '../../assets/scripts/jquery.fullpage.min.js'

var swiper = new Swiper(".banner .swiper-container", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    speed:1000,
    loop:true,//必须
});


$(function(){
	$('#dowebok').fullpage({
		navigation:true,
		verticalCentered:false,
		css3: false,
		scrollingSpeed:800,
		slidesNavigation:false,

		anchors: ['page1', 'page2','page3','page4','page5','page6','page7', 'page8','page9','page10','page11','page12','page13','page14','page15'],
		menu: '#menu',
		autoScrolling: true,
		//anchors: ['hero', 'services', 'cases', 'news','about','contact','footer']
		
		afterLoad: function(anchorLink, index)
		{
			if(index == 10)
			{	

                //设置计数
                $.fn.countTo = function (options) {
                    options = options || {};
                    return $(this).each(function () {
                        //当前元素的选项
                        var settings = $.extend({}, $.fn.countTo.defaults, {
                            from:            $(this).data('from'),
                            to:              $(this).data('to'),
                            speed:           $(this).data('speed'),
                            refreshInterval: $(this).data('refresh-interval'),
                            decimals:        $(this).data('decimals')
                    }, options);
                    //更新值
                    var loops = Math.ceil(settings.speed / settings.refreshInterval),
                    increment = (settings.to - settings.from) / loops;
                    //更改应用和变量
                    var self = this,
                    $self = $(this),
                    loopCount = 0,
                    value = settings.from,
                    data = $self.data('countTo') || {};
                    $self.data('countTo', data);
                    //如果有间断，找到并清除
                    if (data.interval) {
                        clearInterval(data.interval);
                    };
                    data.interval = setInterval(updateTimer, settings.refreshInterval);
                    //初始化起始值
                    render(value);
                    function updateTimer() {
                        value += increment;
                        loopCount++;
                        render(value);
                        if (typeof(settings.onUpdate) == 'function') {
                            settings.onUpdate.call(self, value);
                        }
                        if (loopCount >= loops) {
                            //移出间隔
                            $self.removeData('countTo');
                            clearInterval(data.interval);
                            value = settings.to;
                            if (typeof(settings.onComplete) == 'function') {
                                settings.onComplete.call(self, value);
                            }
                        }
                    }
                    function render(value) {
                        var formattedValue = settings.formatter.call(self, value, settings);
                        $self.html(formattedValue);
                    }
                    });
                };
                $.fn.countTo.defaults={
                    from:0,               //数字开始的值
                    to:0,                 //数字结束的值
                    speed:1000,           //设置步长的时间
                    refreshInterval:100,  //隔间值
                    decimals:0,           //显示小位数
                    formatter: formatter, //渲染之前格式化
                    onUpdate:null,        //每次更新前的回调方法
                    onComplete:null       //完成更新的回调方法
                };
                function formatter(value, settings){
                    return value.toFixed(settings.decimals);
                }
                //自定义格式
                $('#count-number').data('countToOptions',{
                    formmatter:function(value, options){
                        return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
                    }
                });
                //定时器
                $('.timer').each(count);
                function count(options){
                    var $this=$(this);
                    options=$.extend({}, options||{}, $this.data('countToOptions')||{});
                    $this.countTo(options);
                }
			}
		},
	

	});
	$(window).resize(function(){
        autoScrolling();
    });
	/*手机上不滚动*/
	function autoScrolling(){
        var $ww = $(window).width();
        if($ww < 1024){
            $.fn.fullpage.setAutoScrolling(false);
			$.fn.fullpage.setFitToSection(false);
        } else {
            $.fn.fullpage.setAutoScrolling(true);
        }
    }
	autoScrolling();

})

$(".product-nav a").eq(0).addClass("active");
$(".product-list ul").eq(0).addClass("active");
$(".product-nav a").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".product-list ul").eq(index).addClass("active").siblings().removeClass("active");
})

$(".section5 .icon-nav .icon").hover(function() {
    let index = $(this).index();
    $(".section5 ul li").eq(index).addClass("active").siblings().removeClass("active");
    $(".section5 .page .model").css("opacity","1");
})
$(".section6 .icon-nav .icon").hover(function() {
    let index = $(this).index();
    $(".section6 ul li").eq(index).addClass("active").siblings().removeClass("active");
    $(".section6 .page .model").css("opacity","1");
})
$(".section7 .icon-nav .icon").hover(function() {
    let index = $(this).index();
    $(".section7 ul li").eq(index).addClass("active").siblings().removeClass("active");
    $(".section7 .page .model").css("opacity","1");
})
$(".section8 .icon-nav .icon").hover(function() {
    let index = $(this).index();
    $(".section8 ul li").eq(index).addClass("active").siblings().removeClass("active");
    $(".section8 .page .model").css("opacity","1");
})


var swiper = new Swiper(".factory-swiper .swiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    breakpoints: {
        1024: {  //当屏幕宽度小于等于1280
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: '1.82%',
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
        }
    }, 
    navigation: {
        nextEl: ".factory-swiper .swiper-button-next",
        prevEl: ".factory-swiper .swiper-button-prev",
    },
});

var swiper = new Swiper(".partners-swiper .swiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    breakpoints: {
        1024: {  //当屏幕宽度小于等于1280
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: '1.82%',
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
        }
    }, 
    navigation: {
        nextEl: ".partners-swiper .swiper-button-next",
        prevEl: ".partners-swiper .swiper-button-prev",
    },
});